<template>
  <button
    type="button"
    class="book-a-demo"
    :class="{ 'book-a-demo--swipe': useSwipeEffect }"
    :disabled="loading"
    @click="handleClick"
  >
    <slot name="icon">
      <svg
        class="book-a-demo__icon"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <rect
          x="2"
          y="4"
          width="20"
          height="17"
          rx="2"
          stroke="currentColor"
          stroke-width="1.75"
        />
        <path
          d="M2 9h20"
          stroke="currentColor"
          stroke-width="1.75"
          stroke-linecap="round"
        />
        <path
          d="M7 2v4M17 2v4"
          stroke="currentColor"
          stroke-width="1.75"
          stroke-linecap="round"
        />
        <circle cx="8" cy="14" r="1" fill="currentColor" />
        <circle cx="12" cy="14" r="1" fill="currentColor" />
        <circle cx="16" cy="14" r="1" fill="currentColor" />
      </svg>
    </slot>
    <span>{{ text }}</span>
  </button>
</template>

<script setup>
import { computed, ref } from "vue";

const props = defineProps({
  text: {
    type: String,
    default: "Book a Demo",
  },
  useSwipeEffect: {
    type: Boolean,
    default: true,
  },
});

const text = computed(() => props.text);
const useSwipeEffect = computed(() => props.useSwipeEffect);

const emit = defineEmits(["click"]);

const loading = ref(false);

const handleClick = async (e) => {
  if (loading.value) return;
  loading.value = true;
  await emit("click", e);
  loading.value = false;
};
</script>

<style scoped lang="scss">
@keyframes swipe {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(500px);
  }
}

.book-a-demo {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0 1.5rem;
  height: 3rem;
  background: #03b3bb;
  color: #fff;
  border: 1px solid #03b3bb;
  border-radius: 0.75rem;
  font-family: "Poppins";
  font-weight: 600;
  font-size: 1rem;
  line-height: 1.5rem;
  cursor: pointer;
  transition: background-color 0.15s ease;

  &:hover:not(:disabled) {
    background-color: #14bec5;
    border-color: #14bec5;
  }

  &:focus-visible {
    outline: 2px solid #03b3bb;
    outline-offset: 2px;
  }

  &:disabled {
    opacity: 0.65;
    cursor: not-allowed;
  }

  &__icon {
    flex-shrink: 0;
  }

  &--swipe {
    position: relative;
    overflow: hidden;

    &::after {
      content: "";
      position: absolute;
      top: -50px;
      left: -75px;
      width: 80px;
      height: 155px;
      background: white;
      opacity: 0.2;
      transform: rotate(35deg);
      animation: swipe 3s linear infinite;
      z-index: 10;
    }
  }
}
</style>
